// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080',
  TIMEOUT: 30000,
};

// API Endpoints
export const API_ENDPOINTS = {
  // Auth
  REGISTER: '/auth/register',
  LOGIN: '/auth/login',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  
  // User
  PROFILE: '/users/profile',
  UPDATE_PROFILE: '/users/profile',
  USAGE: '/users/usage',
  
  // API Keys
  API_KEYS: '/api-keys',
  API_KEY_BY_ID: (id: string) => `/api-keys/${id}`,
  
  // Screenshots
  SCREENSHOTS: '/screenshots',
  CAPTURE_SCREENSHOT: '/capture',
  
  // Payments
  CREATE_ORDER: '/payments/create-order',
  VERIFY_PAYMENT: '/payments/verify',
  PAYMENT_HISTORY: '/payments/history',
  
  // Health
  HEALTH: '/health',
};

// Payment Gateway Configuration
export const PAYMENT_CONFIG = {
  RAZORPAY: {
    KEY_ID: process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_YOUR_KEY_ID',
    CURRENCY: 'USD',
    NAME: 'ScreenShot API',
    THEME_COLOR: '#000000',
  },
};
